import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import 'vuetify/src/stylus/app.styl';
import colors from 'vuetify/es5/util/colors';


Vue.use(Vuetify, {
  iconfont: 'md',
  card_margin : 'ma-2',
  //rtl : true,
  theme: {
    primary: '#bd2563', 
    //primary: '#37474F', // #E53935
    secondary: '#f57f17', // #FFCDD2
    light_grey : '#D3D3D3',
    accent: colors.indigo.base // #3F51B5
  }
});
